import React from 'react';
import { Row, Col, Card, Button } from 'antd';
import DetailItem from '../../../../CSIComponents/DetailItem';
import ReadOnlyTextarea from '../../../../CSIComponents/ReadOnlyTextarea';
import PageContainer from '../../../../CSIComponents/PageContainer';
import { ClockCircleOutlined } from '@ant-design/icons';

interface propsTypes {
    isEditable: void | any,
    cancelEditable: void | any,
    setOperationType: void | any,
    detailData: any
}

const GeneralDetail = (props: propsTypes) => {
    const policyDes = { label: 'Policy Description', value: props?.detailData?.policies?.general?.description, span: 18 }
    const cancelDes = { label: 'General Cancellation Description', value: props?.detailData?.policies?.general?.generalcancelpolicy, span: 18 }
    const guaranteeDes = { label: 'General Guarantee Policy', value: props?.detailData?.policies?.general?.generalguaranteepolicy, span: 18 }
    const depositDes = { label: 'General Deposit Policy', value: props?.detailData?.policies?.general?.generaldepositpolicy, span: 18 }
    const detailData = [
        { label: 'Check in Time', value: props?.detailData?.policies?.general?.checkintime, span: 6, icon: <ClockCircleOutlined /> },
        { label: 'Check out Time', value: props?.detailData?.policies?.general?.checkouttime, span: 6, icon: <ClockCircleOutlined /> },
        { label: 'Guest Type Restrictions', value: props?.detailData?.policies?.general?.guesttyperestriction, span: 6 },
        { span: 5 },
        { label: 'Minimum Guest Age', value: props?.detailData?.policies?.general?.minguestage, span: 6 },
        { label: 'Maximum Child Age', value: props?.detailData?.policies?.general?.maxchildage, span: 6 },
        { label: 'Children Stay Fee', value: props?.detailData?.policies?.general?.childrenstayfree === 'true' ? 'Yes' : (props?.detailData?.policies?.general?.childrenstayfree === 'false' ? 'No' : ''), span: 6 },
        { span: 5 },
        { label: 'Free Child Cut-Off Age', value: props?.detailData?.policies?.general?.freechildage, span: 6 },
        { label: 'Number of Free Children Per Adult', value: props?.detailData?.policies?.general?.freechildrenperadult, span: 6 },
        { label: 'Room Guaranteed for Late Arrival', value: props?.detailData?.policies?.general?.roomguaranteelatearrival === 'true' ? 'Yes' : (props?.detailData?.policies?.general?.roomguaranteelatearrival === 'false' ? 'No' : ''), span: 6 },
        { span: 5 },
        { label: 'Pets', value: props?.detailData?.policies?.general?.petsallowed, span: 6 },
    ]

    return (
        <PageContainer>
            <Card 
                style={{ marginTop: -15 }} 
                title="General"
                headStyle={{ fontWeight: 600, fontSize: 14, color: '#333', paddingTop: '8px' }} 
                extra={<Button type="primary" className="db-edit-btn" onClick={() => { props.isEditable(); props.setOperationType('edit') }}>Edit</Button>}>
                <div style={{ padding: "0 20px" }}>
                    <Row gutter={24}>
                        <Col span={policyDes.span}>
                            <ReadOnlyTextarea value={policyDes.value} label={policyDes.label} />
                        </Col>
                        <Col span={cancelDes.span}>
                            <ReadOnlyTextarea value={cancelDes.value} label={cancelDes.label} />
                        </Col>
                        <Col span={guaranteeDes.span}>
                            <ReadOnlyTextarea value={guaranteeDes.value} label={guaranteeDes.label} />
                        </Col>
                        <Col span={depositDes.span}>
                            <ReadOnlyTextarea value={depositDes.value} label={depositDes.label} />
                        </Col>
                        <Col span={5}></Col>
                        {detailData.map((item, i) => {
                            return (
                                <React.Fragment key={i}>
                                    {
                                        item.label ? <Col span={item.span} key={i} className="col-margin">
                                            <DetailItem value={item.value} label={item.label}>
                                                {item.icon}
                                            </DetailItem>
                                        </Col> : <Col span={item.span} key={i}></Col>
                                    }
                                </React.Fragment>

                            )
                        })
                        }
                    </Row>
                </div>
            </Card>
        </PageContainer>
    )
}

export default GeneralDetail;



